import { InputViewBox } from "@biggeo/bg-server-lib/studio";
import debounce from "lodash/debounce";
import { useEffect } from "react";

import { getBounds } from "../../utils/geometry-utils";
import { useMap } from "../context";
import { useMapStateUtilities } from "../context/hooks";

export const useViewport = () => {
    const { functionType, viewport, map, polygons, draw, isMapLoaded } =
        useMap();
    const { setViewport } = useMapStateUtilities();

    const onViewportChange = (viewport: InputViewBox) => {
        setViewport(viewport);
    };

    const handleMove = debounce(() => {
        const bounds = map.current?.getBounds();

        if (bounds) {
            const fittedBounds = getBounds(bounds);

            onViewportChange(fittedBounds);

            return fittedBounds;
        }
    }, 250);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
    useEffect(() => {
        const current = map.current;

        if (current) {
            current.on("moveend", handleMove);
            current.on("movestart", () => {
                handleMove.cancel();
            });
        }
        return () => {
            if (current) {
                current.off("moveend", handleMove);
                current.off("movestart", () => {
                    handleMove.cancel();
                });
            }
        };
    }, [
        map.current,
        functionType,
        handleMove,
        polygons.length,
        draw,
        isMapLoaded,
    ]);

    const onStyleLoad = () => {
        handleMove();
    };

    return { onStyleLoad, viewport, bounds: map.current?.getBounds() };
};
